<template>
  <div
    class="plant"
    style="
      max-width: 500px;
      margin-right: auto;
      margin-left: auto;
      position: relative;
    "
  >
    <v-row no-gutters
      ><v-col cols="auto"
        ><v-btn icon class="ma-3" @click="goPrevious()"
          ><v-icon color="primary">mdi-chevron-left</v-icon></v-btn
        ></v-col
      ><v-col align-self="center">
        <v-row no-gutters justify="center" class="text-h4 font-weight-bold"
          ><v-col
            class="secondary--text main-font"
            cols="auto"
            v-if="plant.status"
          >
            {{
              plant.status === "to-give" ? "Plant to give" : "Plant given"
            }}</v-col
          >
        </v-row>
      </v-col>
      <v-col cols="auto"
        ><v-btn v-if="visitor" icon class="ma-3" :to="`/garden/${plant.userId}`"
          ><v-img
            class="shrink rounded-circle"
            :src="plant.userProfilePictureUrl"
            transition="fade-transition"
            height="40"
            width="40"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-icon size="24" color="primary">mdi-account-outline</v-icon>
              </v-row>
            </template>
          </v-img></v-btn
        >
        <v-menu rounded="lg" v-else>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon class="ma-3" v-bind="attrs" v-on="on"
              ><v-icon color="primary">mdi-dots-vertical</v-icon></v-btn
            >
          </template>
          <v-list>
            <template v-for="(item, index) in items">
              <template v-if="item.modify">
                <label for="modify-plant" :key="index">
                  <v-list-item>
                    <v-list-item-icon class="mx-0 pr-5"
                      ><v-icon :color="item.color">{{
                        item.icon
                      }}</v-icon></v-list-item-icon
                    >
                    <v-list-item-title :class="`${item.color}--text`">{{
                      item.title
                    }}</v-list-item-title>
                  </v-list-item>
                </label>
              </template>

              <template v-else>
                <v-list-item :key="index" @click="item.action()">
                  <v-list-item-icon class="mx-0 pr-5"
                    ><v-icon :color="item.color">{{
                      item.icon
                    }}</v-icon></v-list-item-icon
                  >
                  <v-list-item-title :class="`${item.color}--text`">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item>
              </template>
            </template>
          </v-list>
        </v-menu></v-col
      ></v-row
    >

    <v-row no-gutters justify="center" class="px-4">
      <v-img
        @click="$store.commit('fullScreenPicture/setUrl', plant.pictureUrl)"
        class="shrink rounded-xl"
        :src="plant.pictureUrl"
        transition="fade-transition"
        max-height="500"
        style="position: relative"
        @load="pictureLoaded = true"
        ><template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-row>
        </template>
        <v-row
          v-if="plant.id"
          no-gutters
          class="px-6 pb-4"
          justify="center"
          style="position: absolute; bottom: 0; right: 0; left: 0"
        >
          <v-card
            @click.stop.prevent="onClickPlantName()"
            flat
            color="#ffffff33"
            class="rounded-xl glassmorphism"
            style="max-height: 70px"
          >
            <v-row no-gutters class="pa-3" v-if="plant.imageUrl">
              <v-col cols="auto">
                <v-img
                  class="shrink mt-n10"
                  :src="plant.imageUrl"
                  transition="scale-transition"
                  width="80"
                  height="80"
                  ><template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-icon size="30" color="white">mdi-sprout</v-icon>
                    </v-row>
                  </template></v-img
                > </v-col
              ><v-col class="px-2"
                ><v-row
                  no-gutters
                  class="text-subtitle-2 white--text"
                  style="text-shadow: 0px 0px 2px rgba(150, 150, 150, 1)"
                  >{{ plant.name.en }}</v-row
                ><v-row
                  no-gutters
                  class="text-caption font-weight-light white--text"
                >
                  <div
                    class="text-truncate"
                    style="
                      width: 34vw;
                      text-shadow: 0px 1px 1px rgba(150, 150, 150, 1);
                    "
                  >
                    {{ plant.description.en }}
                  </div>
                </v-row></v-col
              >
            </v-row>
            <v-btn
              v-else-if="!visitor"
              depressed
              color="transparent"
              large
              rounded
              class="text-none white--text"
              >Find the name of this plant<v-icon color="white"
                >mdi-menu-down</v-icon
              ></v-btn
            >
          </v-card>

          <v-dialog
            v-model="dialogCategories"
            content-class="dialog-categories"
            overlay-opacity="0.2"
            max-width="calc(100vw - 30px)"
            transition="dialog-bottom-transition"
            origin="center bottom"
            class="rounded-xl"
          >
            <v-card>
              <v-list style="height: 80vh; overflow-y: scroll">
                <v-row
                  no-gutters
                  justify="center"
                  v-if="categoriesPending"
                  class="pa-2"
                >
                  <v-col cols="6" v-for="n in 4" :key="n"
                    ><v-skeleton-loader
                      width="100%"
                      class="px-4 py-2"
                      type="card"
                    ></v-skeleton-loader
                  ></v-col>
                </v-row>
                <template v-else>
                  <v-row no-gutters justify="center">
                    <v-col
                      cols="6"
                      v-for="(category, index) in categories"
                      :key="index"
                      @click="selectCategory(category)"
                    >
                      <v-list-item>
                        <v-col>
                          <v-row no-gutters class="pa-3" justify="center">
                            <v-img
                              class="shrink"
                              :src="category.imageUrl"
                              transition="scale-transition"
                              width="100"
                              height="100"
                              ><template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-icon size="30" color="white"
                                    >mdi-sprout</v-icon
                                  >
                                </v-row>
                              </template></v-img
                            ></v-row
                          >
                          <v-row
                            no-gutters
                            class="text-subtitle-2"
                            justify="center"
                            style="text-align: center"
                            >{{ category.name.en }}</v-row
                          ></v-col
                        >
                      </v-list-item>
                    </v-col>
                  </v-row>
                </template>
              </v-list>
            </v-card>
          </v-dialog>

          <v-dialog
            v-if="plant.name"
            v-model="dialogDescription"
            content-class="dialog-description"
            overlay-opacity="0.2"
            max-width="300"
            transition="dialog-top-transition"
            origin="center top"
            class="rounded-xl"
          >
            <v-card
              class="rounded pa-6"
              @click="dialogDescription = false"
              :ripple="false"
            >
              <v-menu rounded="lg" v-if="!visitor">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    large
                    class="ma-2"
                    v-bind="attrs"
                    v-on="on"
                    style="position: absolute; top: 0; right: 0; z-index: 1"
                    ><v-icon color="secondary">mdi-dots-vertical</v-icon></v-btn
                  >
                </template>
                <v-list>
                  <template v-for="(item, index) in itemsDescription">
                    <template v-if="item.modify">
                      <label for="modify-plant" :key="index">
                        <v-list-item>
                          <v-list-item-icon class="mx-0 pr-5"
                            ><v-icon :color="item.color">{{
                              item.icon
                            }}</v-icon></v-list-item-icon
                          >
                          <v-list-item-title :class="`${item.color}--text`">{{
                            item.title
                          }}</v-list-item-title>
                        </v-list-item>
                      </label>
                    </template>

                    <template v-else>
                      <v-list-item :key="index" @click="item.action()">
                        <v-list-item-icon class="mx-0 pr-5"
                          ><v-icon :color="item.color">{{
                            item.icon
                          }}</v-icon></v-list-item-icon
                        >
                        <v-list-item-title :class="`${item.color}--text`">{{
                          item.title
                        }}</v-list-item-title>
                      </v-list-item>
                    </template>
                  </template>
                </v-list>
              </v-menu>

              <v-row no-gutters justify="center" class="my-2">
                <v-img
                  class="shrink"
                  :src="plant.imageUrl"
                  transition="fade-transition"
                  width="130"
                  height="130"
                  contain
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-icon size="20" color="white"
                        >mdi-flower-tulip-outline</v-icon
                      >
                    </v-row>
                  </template>
                </v-img>
              </v-row>
              <v-row
                no-gutters
                class="text-h5 font-weight-bold"
                justify="center"
                ><span class="main-font">{{ plant.name.en }}</span></v-row
              >
              <v-row no-gutters justify="center" class="text-subtitle-1 pt-3"
                >{{ plant.description.en }}
              </v-row>
            </v-card>
          </v-dialog>
        </v-row>
      </v-img>
    </v-row>

    <v-row no-gutters v-if="plant.descriptionSharing">
      <v-col class="mx-4">
        <v-row no-gutters class="mt-3"
          ><v-col
            align-self="center"
            class="font-weight-medium text-subtitle-1 secondary--text mx-1"
            style="white-space: pre-line"
            >{{ plant.descriptionSharing }}</v-col
          ></v-row
        >
        <v-row no-gutters class="text-caption grey--text mx-1">{{
          handleISOToRelativeTime(plant.createdAt.toDate())
        }}</v-row>
      </v-col>
    </v-row>

    <v-row
      no-gutters
      justify="center"
      class="rounded-t-xl pt-4"
      style="position: relative"
      v-if="pictureLoaded"
    >
      <Comments target="plants" />
    </v-row>
    <input
      type="file"
      id="modify-plant"
      @change="onFileChange"
      accept="image/*"
      style="display: none"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Comments from "../components/Comments.vue";
import resizePicture from "@/utils/resizePicture.js";
import { ISOToRelativeTime } from "@/utils/dates.js";

export default {
  components: {
    Comments,
  },
  data() {
    return {
      prevRoute: null,
      dialogCategories: false,
      dialogDescription: false,
      takePicture: false,
      pictureLoaded: false,
      itemsDescription: [
        {
          title: "Modify category",
          color: "secondary",
          icon: "mdi-sprout-outline",
          action: () => {
            this.dialogCategories = true;
            this.dialogDescription = false;
            this.$store.dispatch("categories/getCategories");
          },
        },
      ],
    };
  },
  computed: {
    items() {
      let items = [
        {
          title: "Modify picture",
          color: "",
          icon: "mdi-camera-outline",
          modify: true,
          action: () => null,
        },
        {
          title: "Delete",
          color: "error",
          icon: "mdi-delete-outline",
          action: () => {
            this.deletePlant();
          },
        },
      ];
      if (!this.plant.status) {
        items.unshift({
          title: "Move to give list",
          color: "primary",
          icon: "mdi-hand-heart-outline",
          action: () => {
            this.save("status", "to-give");
            this.$store.dispatch("level/updateLevel", {
              field: "contributor",
              value: true,
            });
            this.$router.push(`/garden/${this.$route.params.gardenId}`);
          },
        });
      }
      if (this.plant.status === "to-give") {
        items.unshift({
          title: "Move to given list",
          color: "primary",
          icon: "mdi-account-heart-outline",
          action: () => {
            this.save("status", "given");
            this.$router.push(`/garden/${this.$route.params.gardenId}`);
          },
        });
      }
      return items;
    },
    ...mapState("self", ["self"]),

    ...mapState("plants", ["plant"]),
    ...mapState("categories", ["categories", "categoriesPending"]),
    visitor() {
      return this.$route.params.gardenId !== this.self.id;
    },
  },
  beforeDestroy() {
    this.$store.commit("fullScreenPicture/setUrl", null);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  methods: {
    async save(field, value) {
      if (value === "") return;
      let update = {};
      update[field] = value;
      await this.$store.dispatch(`plants/updatePlant`, update);
      this.$store.commit(`snackbar/setSnackbar`, {
        color: "primary",
        timeout: 3000,
        text: "Modification saved",
      });
    },
    onClickPlantName() {
      if (this.visitor) return (this.dialogDescription = true);
      if (this.plant.name) {
        return (this.dialogDescription = true);
      } else {
        this.dialogCategories = true;
        this.$store.dispatch("categories/getCategories");
      }
    },
    handleISOToRelativeTime(date) {
      return ISOToRelativeTime(date);
    },
    async onFileChange(e) {
      try {
        const dataurl = await resizePicture(e.target.files[0], 1000, 1000);
        this.$store.dispatch("plants/modifyPlantPicture", dataurl);
      } catch (error) {
        console.log(error);
      }
    },
    goPrevious() {
      this.prevRoute && this.prevRoute.name
        ? this.$router.go(-1)
        : this.$router.push("/");

      // this.$router.go(-1)
      // this.$router.push("/")
    },
    selectCategory(category) {
      this.dialogCategories = false;
      let newCategory = {
        name: category.name,
        description: category.description,
        imageUrl: category.imageUrl,
      };
      this.$store.dispatch("level/updateLevel", {
        field: "name",
        value: true,
      });
      this.$store.dispatch("plants/updatePlant", newCategory);
      this.$store.commit(`snackbar/setSnackbar`, {
        color: "primary",
        timeout: 3000,
        text: "The name of your plant has been updated",
      });
    },
    deletePlant() {
      this.$store.dispatch("plants/deletePlant", this.plant);
      this.$store.commit(`snackbar/setSnackbar`, {
        color: "primary",
        timeout: 3000,
        text: "Plant deleted",
      });
      this.$router.go(-1);
    },
  },
  watch: {
    "$route.params.plantId": {
      handler: function (val) {
        if (val) {
          this.$store.dispatch("plants/getPlant", {
            gardenId: this.$route.params.gardenId,
            plantId: val,
          });
        }
      },
      immediate: true,
    },
  },
};
</script>

<style>
.dialog-categories {
  position: fixed;
  bottom: 15px;
  margin: 0px;
  border-radius: 20px !important;
}

.dialog-description {
  position: fixed;
  top: 25px;
  margin: 0px;
  border-radius: 20px !important;
}
</style>